import React, {Fragment, useEffect} from 'react';
import i18n from 'i18next';
import Button from "@/Components/Button";
import {ProfileSliderTypes} from "@/Enums/ProfileSliderTypes";

export default function SliderToastFailedMessage({sliderType, failedMessage, setFailedMessage}) {

    useEffect(() => {
        if(failedMessage.isVisible) {
            setTimeout(() => {
                setFailedMessage({isVisible: false, messageType: 'standard_error'});
            }, 5000);
        }
    }, [failedMessage.isVisible]);

    return (
        <Fragment>
            <div
                className={`update-message-active update-failed-message`}>
                <div className="update-failed-message-exclamationtriangle-div update-message-symbol-div">
                    <i className="fas fa-exclamation-triangle"></i>
                </div>
                <div className="update-message-text-div">
                    {failedMessage.messageType === 'standard_error' && sliderType === ProfileSliderTypes.MY_PROFILE && i18n.t("my-profile-slider.update-message.error-standard")}
                    {failedMessage.messageType === 'loading_error' && sliderType === ProfileSliderTypes.MY_PROFILE && i18n.t("my-profile-slider.update-message.error-loading")}
                </div>
                <div className="update-message-close-div">
                    <Button type="button"
                            className="update-failed-message-close-button update-message-close-button"
                            onClick={() => setFailedMessage({isVisible: false, messageType: 'standard_error'})}>
                        <i className="fas fa-times"></i>
                    </Button>
                </div>
            </div>
        </Fragment>
    );
}
